var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.item.hidden
    ? _c(
        "div",
        { staticClass: "menu-wrapper" },
        [
          _vm.noChild(_vm.item)
            ? [
                _c(
                  "app-link",
                  { attrs: { to: _vm.resolvePath(_vm.item.path) } },
                  [
                    _c(
                      "el-menu-item",
                      {
                        attrs: { index: _vm.resolvePath(_vm.item.path) },
                        on: {
                          click: function($event) {
                            return _vm.goRouter(_vm.item.path)
                          }
                        }
                      },
                      [
                        _c("item", {
                          attrs: { title: _vm.item.meta.title },
                          on: {
                            click: function($event) {
                              return _vm.goRouter(_vm.item.path)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  attrs: {
                    index: _vm.resolvePath(_vm.item.path),
                    "popper-append-to-body": ""
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _vm.item.meta
                        ? _c("item", {
                            attrs: {
                              icon: _vm.item.meta && _vm.item.meta.icon,
                              title: _vm.item.meta.title,
                              index: _vm.resolvePath(_vm.item.path)
                            }
                          })
                        : _vm._e(),
                      _vm.item.meta.title === "锐锢在线" &&
                      _vm.orderTotal &&
                      _vm.orderTotal > 0
                        ? _c("span", { staticClass: "menu-warpper-msg" }, [
                            _vm._v(
                              _vm._s(
                                _vm.orderTotal > 99 ? "99+" : _vm.orderTotal
                              )
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.item.children, function(child) {
                    return _c("sidebar-item", {
                      key: child.path,
                      staticClass: "nest-menu",
                      attrs: {
                        item: child,
                        "base-path": _vm.resolvePath(child.path)
                      }
                    })
                  })
                ],
                2
              )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e977306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e977306","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/SiderBar/SidebarItem.vue
// module id = null
// module chunks = 